export default {"src":"/_next/static/image/src/assets/images/favicon.3888b0e329526a975703e3059a02b92d.ico","height":60,"width":60};